const ArrowBar = ({ width = 19, height = 19 }: { width?: number; height?: number }) => {
  return (
    <svg width={`${width}`} height={`${height}`} viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.335 3.167v8.957h-1.279V5.26l-9.985 9.985-.904-.905 9.892-9.893H6.38v-1.28h8.956z"
        fill="#999"
      />
    </svg>
  );
};

export default ArrowBar;
